module.exports = __webpack_public_path__ + "HelveticaLightOblique.c32f4a1102945b15cc71.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/Helvetica/HelveticaLightOblique.eot
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLightOblique.eot
// module chunks = styles